import { render, staticRenderFns } from "./IntraBankTransfer.vue?vue&type=template&id=43e0c07a&scoped=true&"
import script from "./IntraBankTransfer.vue?vue&type=script&lang=js&"
export * from "./IntraBankTransfer.vue?vue&type=script&lang=js&"
import style0 from "./IntraBankTransfer.vue?vue&type=style&index=0&id=43e0c07a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e0c07a",
  null
  
)

export default component.exports